import { useEffect, useState } from "react";
import {
  CmSheetStateEnum,
  DevelopmentTypeEnum,
  PermissionsEnum,
} from "../../../../../constants/AppConstants";
import {
  COMMENTS_LABEL,
  INDICATORS_LABEL,
} from "../../../../../constants/Dictionary";
import { CmSheetSectionProps } from "../SchedaCM";
import { TextSwitch } from "../../../../../components/TextSwitch/TextSwitch";
import { DevelopmentIndicators } from "./DevelopmentIndicators/DevelopmentIndicators";
import { DevelopmentComments } from "./DevelopmentComments/DevelopmentComments";
import { roleHasPermission } from "../../../../../utils/roleAuth.utils";
import { useAppSelector } from "../../../../../hooks/store.hook";

export const DevelopmentCM = ({
  setHeaderTextSwitch,
  setHeaderRightContent,
  isMyProfile,
  cmSheetInfo,
  cmSheetStateMachineInfo,
  ...props
}: CmSheetSectionProps) => {
  const { profile } = useAppSelector((state) => state.user);
  const developmentTypeOptions = [
    { value: DevelopmentTypeEnum.INDICATORS, label: INDICATORS_LABEL },
    { value: DevelopmentTypeEnum.COMMENTS, label: COMMENTS_LABEL },
  ];

  const [selectedDevelopmentType, setSelectedDevelopmentType] = useState(
    developmentTypeOptions[0],
  );

  const hideSwitch = () => {
    if (isMyProfile) {
      if (cmSheetStateMachineInfo.currentState === CmSheetStateEnum.DRAFT) {
        return true;
      }
    }

    if (
      [CmSheetStateEnum.DRAFT].includes(cmSheetStateMachineInfo.currentState) &&
      !roleHasPermission(profile, PermissionsEnum.EDIT_ALL_CM_SHEETS)
    ) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    if (hideSwitch()) {
      return;
    }

    setHeaderTextSwitch(
      <TextSwitch
        selectedOption={selectedDevelopmentType}
        setSelectedOption={setSelectedDevelopmentType}
        options={developmentTypeOptions}
      />,
    );

    if (selectedDevelopmentType.value === DevelopmentTypeEnum.COMMENTS) {
      setHeaderRightContent(null);
    }
  }, [selectedDevelopmentType, cmSheetStateMachineInfo]);

  return (
    <>
      {selectedDevelopmentType.value === DevelopmentTypeEnum.INDICATORS ? (
        <DevelopmentIndicators
          {...props}
          setHeaderRightContent={setHeaderRightContent}
          setHeaderTextSwitch={setHeaderTextSwitch}
          cmSheetInfo={cmSheetInfo}
          cmSheetStateMachineInfo={cmSheetStateMachineInfo}
          isMyProfile={isMyProfile}
        />
      ) : (
        <DevelopmentComments
          {...props}
          setHeaderRightContent={setHeaderRightContent}
          cmSheetInfo={cmSheetInfo}
          cmSheetStateMachineInfo={cmSheetStateMachineInfo}
          isMyProfile={isMyProfile}
          setHeaderTextSwitch={setHeaderTextSwitch}
        />
      )}
    </>
  );
};
